/*
 * Module for the Participant Association Roles Tab
*/
rs.module("participant/account/associations/edit/rolestab",

    ["controls/components/event-banner"],

    function (eventBanner) {

        var _jsSelectors;
        var _tab;

        var _executeSelectionChanged;

        //
        // Initialize
        //
        function initialize(jsSelectors, modelValues, backendUrls, codeValues, grid) {

            _jsSelectors = jsSelectors;
            _tab = $.js(jsSelectors.tab);

            _tab.js(jsSelectors.addLink, { multiple: true }).click(function () {

                grid.selectedValues = null;

                $.post(backendUrls.add, {
                    "roletype": $(this).data("type"),
                    "assocparticipantkey": modelValues.assocParticipantKey,
                    "assocaccountpartykey": modelValues.assocAccountPartyKey,
                    "contactassockey": modelValues.contactAssocKey,
                    "isperson": modelValues.isPerson
                }).done(function (result) {
                    _tab.js(jsSelectors.editor).html(result);
                    _resetValidations();
                    _clearErrors();
                });
            });

            // Listen for row selection 
            grid.selectionChanged(function (values, rows) {

                // This handler fires when the grid is first rendered, but we don't want it to in our case
                // _executeSelectionChanged will be false the first time it runs, after that this will fire every time a row is clicked
                if (_executeSelectionChanged && values.length > 0) {

                    var keys = values[0].split('|');

                    $.post(backendUrls.edit, {
                        "assocparticipantkey": modelValues.assocParticipantKey,
                        "assocaccountpartykey": keys[0],
                        "contactassockey": keys[1],
                        "isperson": modelValues.isPerson
                    }).done(function (result) {
                        _tab.js(jsSelectors.editor).html(result);
                        _resetValidations();
                        _clearErrors();
                    });
                }

                _executeSelectionChanged = true;
            });

            // Register change event for spouse status/effective date
            _tab.on("change", `[data-js=${jsSelectors.spouseEffectiveDate}], [data-js=${jsSelectors.spouseStatusSelect}]`, function () {
                var status = _tab.js(jsSelectors.spouseStatusSelect).val();

                if (status == codeValues.activeSpouse) {
                    _tab.js(jsSelectors.marriageDate).val(_tab.js(jsSelectors.spouseEffectiveDate).val());
                    _tab.js(jsSelectors.divorceDate).val(null);
                }
                else if (status == codeValues.inactiveSpouse) {
                    _tab.js(jsSelectors.divorceDate).val(_tab.js(jsSelectors.spouseEffectiveDate).val());
                }
            });
        }

        ///
        /// Resets unobtrusive validations, which is required after enabling previously disabled fields.
        ///
        function _resetValidations() {

            var form = _tab.js(_jsSelectors.form);

            $.validator.resetValidation(form);
        }

        //
        // Clear event banner and field errors
        //
        function _clearErrors() {
            // clear event banner
            eventBanner.removeAllMessages();
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);